import { isDefined } from "@clipboard-health/util-ts";
import { Box, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";

import { BADGES_DATA, isBadgeType } from "./constants";

interface WorkerBadgeListItemProps {
  badgeName: string;
  onClick?: () => void;
}

export function WorkerBadgeListItem(props: WorkerBadgeListItemProps) {
  const { badgeName, onClick } = props;

  const badgeData = isBadgeType(badgeName) ? BADGES_DATA[badgeName] : null;

  if (!isDefined(badgeData)) {
    return null;
  }

  return (
    <ListItemButton onClick={onClick}>
      <ListItemIcon>
        <Box
          component="img"
          src={badgeData.image}
          alt={badgeName}
          sx={{
            width: 24,
            height: 24,
            objectFit: "cover",
          }}
        />
      </ListItemIcon>
      <ListItemText primary={badgeData.title} secondary={badgeData.description} />
    </ListItemButton>
  );
}
